'use client';
import { jsx as _jsx } from "react/jsx-runtime";
// use client directive included since react hooks are used
import { createContext, useContext } from 'react';
const defaultConfig = {
    featureFlags: {},
    nextPathname: null,
    trackEvent: (_, __) => null,
};
const PantryConfigContext = createContext({ ...defaultConfig });
/**
 * PantryConfig React Context Provider
 * @param props - Props
 * @param props.config - PantryConfig
 * @returns Provider component
 * @example
 * import { ReactNode, useMemo } from 'react';
 * import { usePathname } from 'next/navigation';
 * import { PantryConfigProvider, type PantryConfig } from '@side/pantry';
 * import { useAppFlags } from '../launchdarkly/app-flags';
 * import { useTrackEvent } from '../analytics/use-track-event';
 *
 * export function PantryProvider({ children }: { children: ReactNode }) {
 *   const featureFlags = useAppFlags();
 *   const nextPathname = usePathname();
 *   const trackEvent = useTrackEvent();
 *   const config: PantryConfig = useMemo(
 *     () => ({ featureFlags, nextPathname, trackEvent }),
 *     [featureFlags, nextPathname, trackEvent],
 *   );
 *   return (
 *     <PantryConfigProvider config={config}>{children}</PantryConfigProvider>
 *   );
 * }
 */
export function PantryConfigProvider({ children, config, }) {
    return (_jsx(PantryConfigContext.Provider, { value: config, children: children }));
}
/**
 * @internal – Do not consume this hook outside of Pantry
 */
export function usePantryConfig() {
    return useContext(PantryConfigContext);
}
